/* Estimation des frais de livraison par code postal — tiroir panier et page Panier (15/09/2026).
   Les prix viennent de Shopify (API Storefront, panier de calcul) : rien à modifier ici si les tarifs changent.
   Corse (codes en 20) et hors métropole (97, 98) : message « sur devis », comme sur la page de paiement.
   Barre « Plus que X € » (15/09/2026) : les grilles sont recopiées plus bas, à mettre à jour si les tarifs changent dans Shopify. */
(function () {
  var API = '/api/2025-07/graphql.json';
  var PHONE = '06 09 09 60 79';
  var STORE_KEY = 'hg_cp_livraison';
  var cache = {};

  // Grilles en centimes : [montant du panier à partir duquel, prix de la livraison].
  var GEODIS = [[1700, 4990], [40000, 7900], [75000, 4900], [99000, 0]];
  var LOCAL_ZONES = [
    { deps: ['34', '30', '11', '66'], tiers: [[40000, 4990], [50000, 2990], [75000, 0]] },
    { deps: ['31', '82', '07', '26', '84', '13', '69', '09', '81', '12', '48', '43', '42', '63'], tiers: [[50000, 6990], [60000, 3990], [80000, 0]] }
  ];
  var MIN_SAVING = 1000; // une baisse n'est annoncée qu'à partir de 10 € d'économie
  var HEAVY_TYPES = ['Gazon synthétique', 'Dalle caoutchouc'];

  var CSS =
    '.hg-ship-est{background:#f7fdf0;border:1.5px solid #d8f0b8;border-radius:10px;padding:10px 12px;display:grid;grid-template-columns:minmax(0,1fr);gap:8px;min-width:0;max-width:100%;box-sizing:border-box}' +
    '.hg-ship-est *{box-sizing:border-box}' +
    '.hg-ship-est__label{font-size:13px;font-weight:800;color:var(--hg-navy,#031b34)}' +
    '.hg-ship-est .hg-ship-est__row{display:flex;gap:8px;min-width:0;width:100%}' +
    '.hg-ship-est .hg-ship-est__input{flex:1 1 0;width:100%;min-width:0;max-width:none;height:auto;margin:0;font:inherit;font-size:15px;letter-spacing:.06em;padding:8px 10px;border:1.5px solid #cfe3b4;border-radius:8px;background:#fff;color:var(--hg-navy,#031b34)}' +
    '.hg-ship-est .hg-ship-est__input:focus{outline:2px solid var(--hg-navy,#031b34);outline-offset:1px}' +
    '.hg-ship-est .hg-ship-est__btn{flex:0 0 auto;width:auto;margin:0;font:inherit;font-size:14px;font-weight:800;padding:8px 14px;border:0;border-radius:8px;background:var(--hg-navy,#031b34);color:#fff;cursor:pointer}' +
    '.hg-ship-est .hg-ship-est__btn:focus-visible{outline:2px solid var(--hg-green,#91e404);outline-offset:2px}' +
    '.hg-ship-est__result{min-width:0}' +
    '.hg-ship-est__list{list-style:none;margin:0;padding:0;display:grid;gap:7px;min-width:0}' +
    '.hg-ship-est__opt{display:flex;justify-content:space-between;align-items:center;gap:10px;min-width:0;font-size:13px;color:var(--hg-navy,#031b34)}' +
    '.hg-ship-est__name{display:grid;gap:1px;min-width:0;line-height:1.3;overflow-wrap:anywhere}' +
    '.hg-ship-est__name small{font-size:11.5px;color:var(--hg-text,#5c6570)}' +
    '.hg-ship-est__price{white-space:nowrap;font-weight:800;font-variant-numeric:tabular-nums}' +
    '.hg-ship-est__opt.is-best .hg-ship-est__price{background:var(--hg-green,#91e404);border-radius:6px;padding:1px 7px}' +
    '.hg-ship-est__foot,.hg-ship-est__msg{margin:0;font-size:11.5px;line-height:1.4;color:var(--hg-text,#5c6570)}' +
    '.hg-ship-est__msg--error{color:#c0392b;font-weight:600}' +
    '.hg-ship-est__msg--info{color:var(--hg-navy,#031b34);font-weight:600}' +
    '.hg-ship-est__bar{display:grid;gap:6px;min-width:0}' +
    '.hg-ship-est__bar[hidden]{display:none}' +
    '.hg-ship-est__bar-msg{margin:0;font-size:12.5px;font-weight:700;line-height:1.4;color:var(--hg-navy,#031b34)}' +
    '.hg-ship-est__bar-msg em{font-style:normal;font-weight:900;color:#2e7d0e}' +
    '.hg-ship-est__track{height:7px;background:#e3efd2;border-radius:99px;overflow:hidden}' +
    '.hg-ship-est__fill{height:100%;width:0;background:linear-gradient(90deg,#91e404,#5fb800);border-radius:99px;transition:width .45s ease}' +
    '@media (prefers-reduced-motion:reduce){.hg-ship-est__fill{transition:none}}' +
    '.hg-ship-est--page{margin:6px 0 14px}';

  function esc(s) {
    return String(s).replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }

  function money(amount) {
    var n = Number(amount);
    if (!n) return 'Offerte';
    return n.toLocaleString('fr-FR', { style: 'currency', currency: 'EUR', minimumFractionDigits: Number.isInteger(n) ? 0 : 2 });
  }

  function label(option) {
    if (option.deliveryMethodType === 'LOCAL') return 'Livraison par nos soins';
    if (option.deliveryMethodType === 'PICK_UP') return 'Retrait au dépôt';
    if (option.title === 'Standard') return 'Livraison standard';
    return option.title;
  }

  function token() {
    try {
      return JSON.parse(document.getElementById('shopify-features').textContent).accessToken || null;
    } catch (e) {
      return null;
    }
  }

  function savedZip() {
    try { return localStorage.getItem(STORE_KEY) || ''; } catch (e) { return ''; }
  }

  function saveZip(zip) {
    try { localStorage.setItem(STORE_KEY, zip); } catch (e) {}
  }

  function priceAt(tiers, total) {
    var price = null;
    tiers.forEach(function (t) { if (total >= t[0]) price = t[1]; });
    return price;
  }

  // Prix le moins cher proposé pour ce montant : GEODIS ou livraison par nos soins.
  function bestPrice(total, zone) {
    var national = priceAt(GEODIS, total);
    var local = zone ? priceAt(zone.tiers, total) : null;
    if (national === null) return local;
    if (local === null) return national;
    return Math.min(national, local);
  }

  function zoneFor(zip) {
    var dep = /^\d{5}$/.test(zip) ? zip.slice(0, 2) : '';
    for (var i = 0; i < LOCAL_ZONES.length; i++) {
      if (LOCAL_ZONES[i].deps.indexOf(dep) !== -1) return LOCAL_ZONES[i];
    }
    return null;
  }

  function euros(cents) {
    var n = cents / 100;
    return n.toLocaleString('fr-FR', { style: 'currency', currency: 'EUR', minimumFractionDigits: Number.isInteger(n) ? 0 : 2 });
  }

  // Barre « Plus que X € » : prochain montant où la livraison baisse d'au moins 10 € ou devient offerte.
  // Seulement pour les paniers avec gazon ou dalles ; masquée pour la Corse et l'outre-mer.
  function paintBar(bar, cart) {
    var zip = savedZip();
    var heavy = (cart.items || []).some(function (i) { return HEAVY_TYPES.indexOf(i.product_type) !== -1; });
    if (!heavy || /^(20|97|98)/.test(zip)) { bar.hidden = true; return; }
    var zone = zoneFor(zip);
    var total = cart.total_price;
    var current = bestPrice(total, zone);
    var msg = bar.querySelector('.hg-ship-est__bar-msg');
    var fill = bar.querySelector('.hg-ship-est__fill');
    if (current === 0) {
      msg.innerHTML = '🎉 <em>Livraison offerte</em> pour votre commande';
      fill.style.width = '100%';
      bar.hidden = false;
      return;
    }
    var steps = GEODIS.concat(zone ? zone.tiers : [])
      .map(function (t) { return t[0]; })
      .filter(function (m) { return m > total; })
      .sort(function (a, b) { return a - b; });
    var target = null;
    for (var i = 0; i < steps.length && !target; i++) {
      var p = bestPrice(steps[i], zone);
      if (p !== null && (p === 0 || current === null || current - p >= MIN_SAVING)) target = { amount: steps[i], price: p };
    }
    if (!target) { bar.hidden = true; return; }
    msg.innerHTML = 'Plus que <em>' + euros(target.amount - total) + '</em> ' + (target.price === 0
      ? 'pour la livraison <em>offerte</em>'
      : 'pour payer la livraison <em>' + euros(target.price) + '</em>' + (current !== null ? ' au lieu de ' + euros(current) : ''));
    fill.style.width = Math.max(6, Math.min(100, Math.round(total / target.amount * 100))) + '%';
    bar.hidden = false;
  }

  function updateBar(box) {
    fetch('/cart.js', { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (cart) { paintBar(box.hgBar, cart); })
      .catch(function () {});
  }

  function estimate(zip) {
    return fetch('/cart.js', { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        if (!cart.item_count) return { empty: true };
        var key = zip + '|' + cart.items.map(function (i) { return i.variant_id + 'x' + i.quantity; }).join(',');
        if (cache[key]) return cache[key];
        var t = token();
        if (!t) throw new Error('token');
        var query = 'mutation($input: CartInput!){cartCreate(input:$input){cart{deliveryGroups(first:5){nodes{deliveryOptions{title description deliveryMethodType estimatedCost{amount}}}}}userErrors{message}}}';
        var input = {
          lines: cart.items.map(function (i) {
            return { merchandiseId: 'gid://shopify/ProductVariant/' + i.variant_id, quantity: i.quantity };
          }),
          buyerIdentity: { countryCode: 'FR', deliveryAddressPreferences: [{ deliveryAddress: { zip: zip, country: 'FR' } }] }
        };
        return fetch(API, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', 'X-Shopify-Storefront-Access-Token': t },
          body: JSON.stringify({ query: query, variables: { input: input } })
        })
          .then(function (r) { return r.json(); })
          .then(function (res) {
            var c = res && res.data && res.data.cartCreate && res.data.cartCreate.cart;
            if (!c) throw new Error('api');
            var seen = {};
            var options = [];
            c.deliveryGroups.nodes.forEach(function (g) {
              g.deliveryOptions.forEach(function (o) {
                var k = o.deliveryMethodType + '|' + o.title + '|' + o.estimatedCost.amount;
                if (!seen[k]) { seen[k] = true; options.push(o); }
              });
            });
            options.sort(function (a, b) { return Number(a.estimatedCost.amount) - Number(b.estimatedCost.amount); });
            var data = { options: options, groups: c.deliveryGroups.nodes.length };
            cache[key] = data;
            return data;
          });
      });
  }

  function message(result, type, text) {
    result.innerHTML = '<p class="hg-ship-est__msg hg-ship-est__msg--' + type + '">' + esc(text) + '</p>';
  }

  // Liste compacte : le titre de chaque livraison et son prix à droite, sans détail (15/09/2026).
  function renderOptions(result, data, zip) {
    var pickup = '<li class="hg-ship-est__opt"><span class="hg-ship-est__name">Retrait au dépôt de Vias (34)</span><strong class="hg-ship-est__price">Gratuit</strong></li>';
    if (!data.options.length) {
      result.innerHTML = '<ul class="hg-ship-est__list">' + pickup + '</ul>' +
        '<p class="hg-ship-est__msg hg-ship-est__msg--info">Pas de livraison possible pour ce panier au ' + esc(zip) + '. Appelez-nous au ' + PHONE + '.</p>';
      return;
    }
    var html = '<ul class="hg-ship-est__list">';
    data.options.forEach(function (o, i) {
      html += '<li class="hg-ship-est__opt' + (i === 0 ? ' is-best' : '') + '">' +
        '<span class="hg-ship-est__name">' + esc(label(o)) + '</span>' +
        '<strong class="hg-ship-est__price">' + money(o.estimatedCost.amount) + '</strong></li>';
    });
    html += pickup + '</ul>';
    if (data.groups > 1) html += '<p class="hg-ship-est__foot">Commande livrée en plusieurs colis.</p>';
    result.innerHTML = html;
  }

  function build(context) {
    var id = 'hg-ship-est-' + context;
    var box = document.createElement('div');
    box.className = 'hg-ship-est hg-ship-est--' + context;
    box.innerHTML =
      '<div class="hg-ship-est__bar" hidden><p class="hg-ship-est__bar-msg"></p><div class="hg-ship-est__track"><div class="hg-ship-est__fill"></div></div></div>' +
      '<label class="hg-ship-est__label" for="' + id + '">Estimer la livraison</label>' +
      '<div class="hg-ship-est__row">' +
      '<input id="' + id + '" class="hg-ship-est__input" type="text" inputmode="numeric" autocomplete="postal-code" maxlength="5" placeholder="Votre code postal">' +
      '<button type="button" class="hg-ship-est__btn">Calculer</button>' +
      '</div>' +
      '<div class="hg-ship-est__result" aria-live="polite"></div>';
    var input = box.querySelector('input');
    var button = box.querySelector('button');
    var result = box.querySelector('.hg-ship-est__result');
    box.hgBar = box.querySelector('.hg-ship-est__bar');
    input.value = savedZip();

    function run() {
      var zip = input.value.replace(/\D/g, '').slice(0, 5);
      input.value = zip;
      if (zip.length !== 5) {
        message(result, 'error', 'Entrez un code postal à 5 chiffres.');
        return;
      }
      saveZip(zip);
      updateBar(box);
      if (/^20/.test(zip)) {
        message(result, 'info', 'Nous ne livrons pas la Corse en ligne. Devis au ' + PHONE + '.');
        return;
      }
      if (/^9[78]/.test(zip)) {
        message(result, 'info', 'Hors France métropolitaine : livraison sur devis au ' + PHONE + '.');
        return;
      }
      message(result, 'loading', 'Calcul en cours…');
      estimate(zip)
        .then(function (data) {
          if (data.empty) { result.innerHTML = ''; return; }
          if (input.value !== zip) return;
          renderOptions(result, data, zip);
        })
        .catch(function () {
          message(result, 'error', 'Estimation indisponible pour le moment. Les frais exacts s’affichent au paiement.');
        });
    }

    button.addEventListener('click', run);
    input.addEventListener('keydown', function (e) {
      if (e.key === 'Enter') { e.preventDefault(); run(); }
    });
    input.addEventListener('input', function () {
      if (input.value.replace(/\D/g, '').length === 5) run();
    });
    box.hgRun = run;
    box.hgInput = input;
    return box;
  }

  function rerunWithSaved(box) {
    var zip = savedZip();
    if (!/^\d{5}$/.test(zip)) return;
    box.hgInput.value = zip;
    box.hgRun();
  }

  function mountDrawer() {
    var footer = document.getElementById('hg-cart-drawer-footer');
    var total = footer && footer.querySelector('.hg-cart-drawer__total');
    if (!total || footer.querySelector('.hg-ship-est')) return;
    var box = build('drawer');
    footer.insertBefore(box, total);
    var timer = null;
    function schedule() {
      clearTimeout(timer);
      timer = setTimeout(function () { updateBar(box); rerunWithSaved(box); }, 350);
    }
    var totalEl = document.getElementById('hg-cart-drawer-total');
    if (totalEl) new MutationObserver(schedule).observe(totalEl, { childList: true, characterData: true, subtree: true });
    var drawer = document.getElementById('hg-cart-drawer');
    if (drawer) {
      new MutationObserver(function (mutations) {
        mutations.forEach(function (m) {
          if (m.attributeName === 'class' && drawer.classList.contains('open')) schedule();
        });
      }).observe(drawer, { attributes: true });
    }
  }

  function mountPage() {
    var summary = document.getElementById('hg-cart-summary');
    if (!summary || summary.querySelector('.hg-ship-est')) return;
    var checkout = summary.querySelector('.hg-cart-summary__checkout');
    var box = build('page');
    summary.insertBefore(box, checkout || null);
    updateBar(box);
    rerunWithSaved(box);
  }

  function init() {
    if (!document.getElementById('hg-ship-est-css')) {
      var style = document.createElement('style');
      style.id = 'hg-ship-est-css';
      style.textContent = CSS;
      document.head.appendChild(style);
    }
    mountDrawer();
    mountPage();
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
